/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ id: NonNullable<unknown> }} Projects_Synced_IdInputs */

const cs_projects_synced_id = /** @type {(inputs: Projects_Synced_IdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Synchronizováno · ${i?.id}`)
};

const en_projects_synced_id = /** @type {(inputs: Projects_Synced_IdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Synced · ${i?.id}`)
};

/**
* | output |
* | --- |
* | "Synced · {id}" |
*
* @param {Projects_Synced_IdInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_synced_id = /** @type {((inputs: Projects_Synced_IdInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Synced_IdInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_synced_id(inputs)
	return cs_projects_synced_id(inputs)
});